<template>
  <!-- <v-lay/out row> -->
  <!-- <v-flex md3> -->
  <!-- <ChatList/> -->
  <!-- </v-flex> -->
  <!-- <v-flex md9> -->
  <!-- <ChatChannel/> -->
  <!-- </v-flex> -->
  <!-- </v-layout> -->
</template>

<template>
  <v-container class="fill-height pa-0 ma-0 chat-drawer-container fluid">
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-layout row>
        <v-flex md4 lg3 class="chat-contact--sidebar white">
          <ChatList/>
        </v-flex>
        <v-flex md8 lg9>
          <ChatChannel/>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout column>
        <v-flex sm12 class="white" v-if="dfbstore ? dfbstore.showContact : true">
          <ChatList/>
        </v-flex>
        <v-flex sm12 v-else>
          <ChatChannel/>
        </v-flex>
      </v-layout>
    </template>
  </v-container>
</template>


<script>
// import HelloWorld from '../components/HelloWorld'
import ChatList from "../../components/Chat/ChatList";
import ChatChannel from "./ChatChannel";
import { fbstore } from "../../config/fbstore";
export default {
  components: {
    ChatList,
    ChatChannel
  },
  data() {
    return {
      chat: null,
      selectedTab: null,
      dfbstore: fbstore
    };
  },
  computed: {
    showSidebar() {
      var a = fbstore.currentChan;
      return fbstore.currentChan == "";
    },
    showWindow() {
      var a = fbstore.currentChan;
      return fbstore.currentChan != "";
    }
  }
};
</script>